import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AppComponent } from './app.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { HomeComponent } from './pages/home/home.component';
import { NavigationLayoutComponent } from './@layouts/navigation-layout/navigation-layout.component';
import { RouteTitle } from './utils/symbol.util';
import { RoleGuard } from './auth/guard/role.guard';
import { ChangePasswordComponent } from './pages/user-profile/change-password/change-password.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ManageUserRequestsComponent } from './pages/user-management/manage-user-requests/manage-user-requests.component';
import { CreateMyComplaintComponent } from './pages/manage-complaints/create-my-complaint/create-my-complaint.component';
import { ManageJobCardsComponent } from './pages/manage-complaints/manage-job-cards/manage-job-cards.component';
import { CreateComplaintComponent } from './pages/manage-complaints/create-complaint/create-complaint.component';
import { JobCardReportsComponent } from './pages/reports/job-card-reports/job-card-reports.component';
import { ReportsDashboardComponent } from './pages/reports/reports-dashboard/reports-dashboard.component';
import { ManageComplaintsDashboardComponent } from './pages/manage-complaints/manage-complaints-dashboard/manage-complaints-dashboard.component';
import { ComplaintReportsComponent } from './pages/reports/complaint-reports/complaint-reports.component';
import { ManageResidentsComponent } from './pages/user-management/manage-residents/manage-residents.component';
import { UserManagementDashboardComponent } from './pages/user-management/user-management-dashboard/user-management-dashboard.component';
// import { JasperReportsComponent } from './pages/reports/jasper-reports/jasper-reports.component';
import { ComplaintsSummaryComponent } from './pages/reports/complaints-summary/complaints-summary.component';
import { JasperReportsComponent } from './pages/reports/jasper-reports/jasper-reports.component';
import { ManageEmployeeComponent } from './pages/manage-employee/manage-employee.component';

export const routes: Routes = [
    {
        path: 'app',
        title: 'Home',
        data: { [RouteTitle]: 'Home' },
        component: NavigationLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                component: HomeComponent,
                title: 'Home',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Home',
                    roles: [
                        'ROLE_USER',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_ADMIN',
                        'ROLE_GE',
                        'ROLE_CE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'user-profile',
                component: UserProfileComponent,
                title: 'User Profile',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'User Profile',
                    roles: [
                        'ROLE_USER',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_ADMIN',
                        'ROLE_GE',
                        'ROLE_CE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'user-profile/change-password',
                component: ChangePasswordComponent,
                title: 'Change Password',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Change Password',
                    roles: [
                        'ROLE_USER',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_ADMIN',
                        'ROLE_GE',
                        'ROLE_CE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'create-my-complaint',
                component: CreateMyComplaintComponent,
                title: 'Create My Complaint',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Create My Complaint',
                    roles: [
                        'ROLE_USER',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_ADMIN',
                        'ROLE_GE',
                        'ROLE_CE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'create-complaint',
                component: CreateComplaintComponent,
                title: 'Create Complaint',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Create Complaint',
                    roles: [
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_ADMIN',
                        'ROLE_GE',
                        'ROLE_CE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'user-management',
                component: UserManagementDashboardComponent,
                title: 'User Management',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'User Management',
                    roles: [
                        'ROLE_ADMIN'
                    ]
                },
            },
            {
                path: 'user-management/user-requests',
                component: ManageUserRequestsComponent,
                title: 'User Requests',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'User Requests',
                    roles: [
                        'ROLE_ADMIN'
                    ]
                },
            },
            {
                path: 'user-management/manage-residents',
                component: ManageResidentsComponent,
                title: 'Manage Residents',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Manage Residents',
                    roles: [
                        'ROLE_ADMIN'
                    ]
                },
            },
            {
                path: 'manage-complaints/manage-job-cards',
                component: ManageJobCardsComponent,
                title: 'Job Cards',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Job Cards',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'reports/job-card-report',
                component: JobCardReportsComponent,
                title: 'Job Card Report',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Job Card Report',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'reports/complaint-report',
                component: ComplaintReportsComponent,
                title: 'Complaint Report',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Complaint Report',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS',
                        'ROLE_CE'
                    ] // Allow all roles
                },
            },
            {
                path: 'reports/complaints-summary-report',
                component: ComplaintsSummaryComponent,
                title: 'Complaints Summary Report',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Complaints Summary Report',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS',
                        'ROLE_CE'
                    ] // Allow all roles
                },
            },
            {
                path: 'reports/jasper-report',
                component: JasperReportsComponent,
                title: 'Jasper Report',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Jasper Report',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS',
                        'ROLE_CE'
                    ] // Allow all roles
                },
            },
            {
                path: 'reports',
                component: ReportsDashboardComponent,
                title: 'Reports',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Reports',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS'
                    ] // Allow all roles
                },
            },
            {
                path: 'manage-complaints',
                component: ManageComplaintsDashboardComponent,
                title: 'Manage Complaints',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: {
                    [RouteTitle]: 'Manage Complaints',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS'
                    ]
                },
            },
                                        {
                path: 'manage-employees',
                component: ManageEmployeeComponent,
                title: 'Manage Employees',
                canActivate: [RoleGuard], // Protecting route with RoleGuard
                data: { 
                    [RouteTitle]: 'Manage Employees',
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_JE',
                        'ROLE_AGE',
                        'ROLE_GE',
                        'ROLE_ZS'
                    ]
                },
            },
        ]
    },
    {
        path: 'app/login',
        title: 'Login',
        data: { [RouteTitle]: 'Login' },
        component: LoginComponent
    },
    {
        path: 'app/forgot-password',
        title: 'Forget Password',
        data: { [RouteTitle]: 'Forget Password' },
        component: ForgotPasswordComponent,
    },
    {
        path: 'app/sign-up',
        title: 'Sign Up',
        // canActivate: [RoleGuard], // Protecting route with RoleGuard
        data: {
            [RouteTitle]: 'Sign Up'
        },
        component: SignUpComponent,
    },
    {
        path: '**',
        title: 'Page Not Found',
        data: { [RouteTitle]: 'Page Not Found' },
        component: PageNotFoundComponent
    },
    {
        path: '',
        title: 'MesFS',
        data: { [RouteTitle]: 'Home' },
        component: AppComponent
    }
];
